import React from 'react';
import Icon from '../../../../../muiComponents/Icon';

interface NavigationArrowsProps {
    onPrevClick: () => void;
    onNextClick: () => void;
}
const NavigationArrows = (props: NavigationArrowsProps) => {
    const { onPrevClick, onNextClick } = props;
    return (
        <>
            <Icon
                className='carousel__button --left'
                iconName='KeyboardArrowLeft'
                onClick={onPrevClick}
            />

            <Icon
                className='carousel__button --right'
                iconName='KeyboardArrowRight'
                onClick={onNextClick}
            />
        </>
    );
};

export default NavigationArrows;
